import { render, staticRenderFns } from "./ToxicChemicalDrawer.vue?vue&type=template&id=7c58e3ae&"
import script from "./ToxicChemicalDrawer.vue?vue&type=script&lang=js&"
export * from "./ToxicChemicalDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports